import { render, staticRenderFns } from "./QuotationsRegularView.vue?vue&type=template&id=1044245e"
import script from "./QuotationsRegularView.vue?vue&type=script&lang=js"
export * from "./QuotationsRegularView.vue?vue&type=script&lang=js"
import style0 from "./QuotationsRegularView.vue?vue&type=style&index=0&id=1044245e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports